import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { toast } from 'react-toastify';
import ExpenseForm from '../../components/Expenses/ExpenseForm';
import expenseService from '../../services/expenseService';

const ExpenseEdit = () => {
  const { id } = useParams();
  const [expense, setExpense] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadExpense();
  }, [id]);

  const loadExpense = async () => {
    try {
      const data = await expenseService.getExpense(id);
      setExpense(data.data);
    } catch (error) {
      console.error('Error loading expense:', error);
      toast.error('Failed to load expense');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading expense...</div>
      </div>
    );
  }

  if (!expense) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900">Expense not found</h2>
          <Link to="/app/expenses" className="text-blue-600 hover:text-blue-800 mt-4 inline-block">
            Back to Expenses
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Link
          to="/app/expenses"
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <FiArrowLeft className="mr-2" />
          Back to Expenses
        </Link>
        <h1 className="text-3xl font-bold text-gray-900">Edit Expense</h1>
        <p className="text-gray-600 mt-1">
          Update expense: {expense.description}
        </p>
      </div>

      <ExpenseForm expense={expense} />
    </div>
  );
};

export default ExpenseEdit;

